import type { NotificationPreferences } from '@/lib/api/common/notification-preferences-api'
'use server'

import { apiRequest, ApiResponse } from '../request'
import { PartnerPayoutScheduleType } from '../common/interfaces/partner.interface'

export interface Hospital {
    /**
     * Canais por onde esta entidade aceita ser notificada. Ausente = nada: só recebe
     * quem consentiu. Ver `notification-preferences-api.ts`.
     */
    notificationPreferences?: NotificationPreferences | null
    id: number
    name: string
    tradingName?: string
    cnpj?: string
    cnes?: string
    phone?: string
    phone2?: string
    email?: string
    website?: string
    street?: string
    number?: string
    complement?: string
    neighborhood?: string
    city?: string
    state?: string
    zipCode?: string
    country?: string
    description?: string
    active: boolean
    payoutScheduleType?: PartnerPayoutScheduleType
    payoutFixedDay?: number | null
    payoutDaysAfterAppointment?: number | null
    organizationId: number
    createdAt: string
    updatedAt: string
    organization?: {
        id: number
        name: string
        tradingName?: string
    }
    professionals?: Array<{
        id: number
        professional: {
            id: number
            name: string
            registrationNumber?: string
            councilName?: string
        }
    }>
}

export interface CreateHospitalData {
    name: string
    tradingName?: string
    cnpj?: string
    cnes?: string
    phone?: string
    phone2?: string
    email?: string
    website?: string
    street?: string
    number?: string
    complement?: string
    neighborhood?: string
    city?: string
    state?: string
    zipCode?: string
    country?: string
    description?: string
    active?: boolean
    payoutScheduleType?: PartnerPayoutScheduleType
    payoutFixedDay?: number | null
    payoutDaysAfterAppointment?: number | null
    organizationId: number
}

export interface UpdateHospitalData {
    name?: string
    tradingName?: string
    cnpj?: string
    cnes?: string
    phone?: string
    phone2?: string
    email?: string
    website?: string
    street?: string
    number?: string
    complement?: string
    neighborhood?: string
    city?: string
    state?: string
    zipCode?: string
    country?: string
    description?: string
    active?: boolean
    payoutScheduleType?: PartnerPayoutScheduleType
    payoutFixedDay?: number | null
    payoutDaysAfterAppointment?: number | null
}

export async function getHospitalsByOrganization(
    organizationId: number,
    params?: { page?: number; limit?: number; search?: string },
): Promise<ApiResponse<Hospital[]>> {
    return apiRequest<Hospital[]>(`hospitals/organization/${organizationId}`, {
        params: params ?? {},
    })
}

export async function getHospital(
    id: number,
): Promise<ApiResponse<Hospital>> {
    return apiRequest<Hospital>(`hospitals/${id}`, {})
}

export async function createHospital(
    data: CreateHospitalData,
): Promise<ApiResponse<Hospital>> {
    return apiRequest<Hospital>('hospitals', { data }, 'post')
}

export async function updateHospital(
    id: number,
    data: UpdateHospitalData,
): Promise<ApiResponse<Hospital>> {
    return apiRequest<Hospital>(`hospitals/${id}`, { data }, 'patch')
}

export async function deleteHospital(
    id: number,
): Promise<ApiResponse<void>> {
    return apiRequest<void>(`hospitals/${id}`, {}, 'delete')
}

export async function toggleHospitalActive(
    id: number,
): Promise<ApiResponse<Hospital>> {
    return apiRequest<Hospital>(`hospitals/${id}/toggle-active`, {}, 'patch')
}
